import {convertDates} from '../../utils/helper'

export const UTILS_LOADING_START = 'UTILS_LOADING_START'
export const UTILS_LOADING_END = 'UTILS_LOADING_END'
export const UTILS_LOADING_START_WITH_SLIDER = 'UTILS_LOADING_START_WITH_SLIDER'
export const UTILS_LOADING_END_WITH_SLIDER = 'UTILS_LOADING_END_WITH_SLIDER'
export const UTILS_NORMALIZE_DATES = 'UTILS_NORMALIZE_DATE'
export const UPDATE_VARIABLE_STEP = 'UPDATE_VARIABLE_STEP'

const state = {
  utils: {
    modified: false,
    loading: false,
    slider: false
  },
  variables: {
    step: 0
  },
  error: ''
}

const getters = {
  isLoading: state => {
    return state.utils.loading
  },
  isSlider: state => {
    return state.utils.slider
  },
  getVariableStep: state => {
    return state.variables.step
  }
}

const mutations = {
  [UTILS_LOADING_START_WITH_SLIDER] (state) {
    state.utils.loading = true
    state.utils.slider = true
  },
  [UTILS_LOADING_END_WITH_SLIDER] (state) {
    state.utils.loading = false
    state.utils.slider = false
  },
  [UTILS_LOADING_START] (state) {
    state.utils.loading = true
  },
  [UTILS_LOADING_END] (state) {
    state.utils.loading = false
  },
  [UTILS_NORMALIZE_DATES] (state, rootState) {
    convertDates(rootState)
  },
  [UPDATE_VARIABLE_STEP] (state, payload) {
    state.variables.step = payload
  }
}

const actions = {
  loadingStartWithSlider ({ commit }) {
    commit(UTILS_LOADING_START_WITH_SLIDER)
  },
  loadingEndWithSlider ({ commit }) {
    commit(UTILS_LOADING_END_WITH_SLIDER)
  },
  loadingStart ({ commit }) {
    commit(UTILS_LOADING_START)
  },
  loadingEnd ({ commit }) {
    commit(UTILS_LOADING_END)
  },
  normalizeDates ({ commit, state, rootState }) {
    commit(UTILS_NORMALIZE_DATES, rootState)
  },
  updateVariableStep ({ commit, state }, payload) {
    commit(UPDATE_VARIABLE_STEP, payload)
  },
  resetVariableStep ({ commit }) {
    commit(UPDATE_VARIABLE_STEP, 0)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/front/store/modules/utils.js